module.exports = __webpack_public_path__ + "static/media/matching-score-rank-3.935b537d.png";